import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidOddOneOut } from '../../../../../mechanics/rid-odd-one-out/rid-odd-one-out';

@Component({
  selector: 'app-odd-one-out-words-page',
  imports: [RidOddOneOut],
  templateUrl: './odd-one-out-words-page.html',
})
export class OddOneOutWordsPage {
  protected readonly $router = inject(Router);
}
